const menuTriggers = document.querySelectorAll('[data-sidebar] .sidebar__menu-trigger')

if(menuTriggers) {
  menuTriggers.forEach(trigger => {
    trigger.addEventListener('click', e => {
      trigger.classList.toggle('is-open')
      trigger.nextElementSibling.classList.toggle('is-open')
    })
  })
}